<template>
	<v-container class="rc-teOfrece__content rc-padding fluid">
        <div class="rc-teOfrece">
            <h2>{{titulo}}</h2>
            <ul class="ofrece__list">
                <li class="list__item" v-for="(item, key) in listado" :key="key">
                    <span>·</span> {{item}}
                </li>
            </ul>
        </div>
	</v-container>
</template>

<script>
	import { Component, Vue } from "vue-property-decorator";
	
	@Component({
		props: {
			titulo : String,
			listado : Array
        },
	})
	export default class TeOfrece extends Vue {}
</script>

<style lang="scss" scoped>
    .rc-teOfrece__content{
        min-height: 240px;
        display:flex;
        justify-content:center;
        width:100%
    }
    .rc-teOfrece{
        display: flex;
        justify-content: center;
        flex-flow: column;
        align-items: center;
        background-color: #fcfcfc;
        border-radius: 25px;
        padding: 1rem;
        filter: $rc-dropshadow;
        h2{
            font-size: 2.5rem !important;
            font-weight: 600 !important;
            color: $rc-prim-n1 !important;
            margin-bottom: 1rem;
        }

        .ofrece__list{
            //list-style: none;
            width: 100%;
            display: inline-flex;
            flex-wrap: wrap;
            padding-left: 0;
            .list__item{
                display: flex;
                flex: 1 1 26%;
                justify-content: center;
                color: $rc-prim-g1;
                margin-left: 10px;
                margin-right: 10px;
                font-size: 1rem;
                text-align: center;
                margin-bottom: 10px !important;
                span{
                    color: $rc-prim-n2;
                    font-size: 3rem;
                    line-height: 0.55;
                }
            }
        }
    }

	// Breakpoints 
	@each $breakpoint in $breakpoints_screen_text{
		@include breakpoint_media_queries($breakpoint){
			@if $breakpoint == "x-large"{
				.rc-teOfrece{
                    max-width: 1444px;
                }
			}@else if $breakpoint == "large"{
				
			}@else if $breakpoint == "medium-to-large"{
				.rc-teOfrece__content{
                    display: block;
                }
			}@else if $breakpoint == "small-to-medium"{
                .rc-teOfrece__content{
                    display: block;
                }
                .ofrece__list{
                    display: flex;
                    flex-flow: column;
                    .list__item{
                        margin-left: 0px !important;
                        margin-right: 0px !important;
                        margin-bottom: 10px !important;
                    }
                }
			}@else if $breakpoint == "small"{
                .rc-teOfrece{
                    text-align: center;
                }
                .rc-teOfrece__content{
                    display: block;
                }
                .ofrece__list{
                    display: flex;
                    flex-flow: column;
                    .list__item{
                        margin-left: 0px !important;
                        margin-right: 0px !important;
                        margin-bottom: 10px !important;
                    }
                }
            }
		}
	}
</style>
